var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"category-button",attrs:{"elevation":"10","fab":"","rounded":"","x-large":""},on:{"click":_vm.emitClicked}},[_c('div',{staticClass:"d-flex flex-column align-center"},[(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }